var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.buildOrderCodeDetails()
    ? _c(
        "div",
        {
          staticClass: "emd-container _type_card eu-mt_4",
          attrs: { "data-testid": "order-code-details" },
        },
        [
          _c("div", { staticClass: "emd-container__content " }, [
            _c("h2", { staticClass: "el-chunk" }, [
              _vm._v(_vm._s(_vm.$t("orderCode.label"))),
            ]),
            _c(
              "p",
              {
                staticClass: "emd-text _size_small",
                staticStyle: { overflow: "hidden" },
              },
              [_vm._v(_vm._s(_vm.$t(_vm.buildOrderCodeDetails())))]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }